const CustomersService = {
  /**
   * Get customers with payload
   * @param {Object} payload
   * @returns {Object}
   */
  getCustomers: async (payload) => {
    const params = Object.keys(payload).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`).join('&');
    const { data, headers } = await ovpFetch(`/crm/customers?${params}`);

    const pagination = {
      max_page: 1,
      current_page: payload.page || 1,
    };

    let total = 0;

    const { link } = headers;
    if (link) {
      const linkSplit = link.split(',');
      const lastIndex = linkSplit.findIndex(rel => rel.includes('rel="last"'));
      const prevIndex = linkSplit.findIndex(rel => rel.includes('rel="prev"'));
      if (lastIndex > -1) {
        pagination.max_page = parseInt(linkSplit[lastIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10);
      } else if (prevIndex > -1) {
        pagination.max_page = parseInt(linkSplit[prevIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10) + 1;
      }
      pagination.current_page = pagination.max_page < pagination.current_page ? pagination.max_page : pagination.current_page;
    }

    if (headers['total-count']) {
      total = headers['total-count'];
    }

    return {
      customers: data,
      pagination,
      total,
    };
  },
  /**
   * Get customer by id
   * @param {String} id
   * @returns {Object}
   */
  getCustomer: async (id) => {
    const { data } = await ovpFetch(`/crm/customers/${id}`);
    return data;
  },
  getCustomerActivity: async (id) => {
    const { data } = await ovpFetch(`/crm/customers/${id}/activity`);
    return data;
  },
  deleteCustomers: async (ids) => {
    await ovpFetch('/crm/customers', {
      method: 'DELETE',
      body: ids ? JSON.stringify({ ids }) : JSON.stringify({ ids: [] }),
      iLikeItRaw: true,
    });
    return true;
  },
  exportCustomers: async (ids) => {
    const { data } = await ovpFetch('/crm/customers/export', {
      method: 'POST',
      body: ids ? JSON.stringify({ ids }) : JSON.stringify({ ids: [] }),
      iLikeItRaw: true,
    });
    return data;
  },
  addNote: async (id, note) => {
    const { data } = await ovpFetch(`/crm/customers/${id}/note`, {
      method: 'POST',
      body: JSON.stringify({ body: note }),
    });
    return data;
  },
  deleteNote: async (id, note) => {
    const { data } = await ovpFetch(`/crm/customers/${id}/note/${note}`, {
      method: 'DELETE',
      iLikeItRaw: true,
    });
    return data;
  },
};

// eslint-disable-next-line
export { CustomersService };
